const Banner = () => {
  return (
    <>
      <section className="banner-section">
        <div className="container">
          <div className="banner-content" data-aos="fade-up">
            <img
              src={process.env.PUBLIC_URL + "/img/carbonheader.webp"}
              alt=""
              className="logo"
            />
            <p>
              A high-performance, self-updating framework with full Oxide plugin
              compatibility and the latest C# and Harmony tools, empowering
              developers to unleash their creativity.
            </p>
            <img src={process.env.PUBLIC_URL + "/img/caret-down.png"} alt="" />
          </div>
        </div>
        <img
          src={process.env.PUBLIC_URL + "/img/banner-center-shape.png"}
          className="center-shape"
          alt=""
        />
      </section>
      <div className="d-flex flex-wrap justify-content-center overflow-hidden">
        <div className="w-100 banner-line"></div>
        <img
          src={process.env.PUBLIC_URL + "/img/banner-bottom-shape.png"}
          alt=""
          className="mw-100 banner-bottom-shape"
        />
      </div>
    </>
  );
};
export default Banner;
